<template>
    <van-swipe-cell :on-close="onClose">
        <div class="other-comment-item" @click="clickItem">
            <p>
                <span class="other-ci-title">{{discussData.title}}</span>
                <i class="iconfont icon-bianji layout-glt-icon" @click.stop='clickEdit'></i>
            </p>
            <p>
                <span class="other-ci-time">{{discussData.timeText}}</span>
            </p>
        </div>
        <template slot="right">
            <div class="com-record-delete other-ci-delete">删除</div>
        </template>
    </van-swipe-cell>
</template>

<script>
export default {
    name: 'DiscussListItem',
    props: ['discussData', 'itemFunc', 'editFunc', 'deleteFunc'],
    methods: {
        // 查看
        clickItem() {
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc(this.discussData)
            }
        },
        // 编辑
        clickEdit() {
            if(this.editFunc && typeof(this.editFunc) == 'function') {
                this.editFunc(this.discussData)
            }
        },
        // 删除
        onClose(clickPosition, instance) {
            switch (clickPosition) {
                case 'cell':
                case 'outside':
                    instance.close();
                    break;
                case 'right':
                    this.$dialog.confirm({
                        message: '确定要删除这一条记录吗？'
                    }).then(() => {
                        // on confirm
                        if(this.deleteFunc && typeof(this.deleteFunc) == 'function') {
                            this.deleteFunc(this.discussData.id);
                        }
                    }).catch(() => {
                        // on cancel
                        instance.close();
                    }); 
                break;
            }
        }
    }
}
</script>